/* Picks Shop · movimiento. Mejora progresiva: sin JS todo se ve; con "reducir movimiento" todo queda quieto. */
(function () {
  'use strict';
  if (window.__psMotion) return;
  window.__psMotion = true;

  var d = document, root = d.documentElement, win = window;
  var reduced = win.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = win.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var touchy = win.matchMedia('(pointer: coarse)').matches;
  var raf = win.requestAnimationFrame.bind(win);

  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || d).querySelectorAll(sel)); }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function lerp(a, b, t) { return a + (b - a) * t; }

  // Horizon (escritorio ≥ 990 px) desplaza dentro de .page-wrapper, no en la ventana.
  var mqWrap = win.matchMedia('(min-width: 990px)');
  var wrap = null;
  function getWrap() { return wrap || (wrap = d.querySelector('.page-wrapper')); }
  function getY() { var w = mqWrap.matches ? getWrap() : null; return w ? w.scrollTop : win.pageYOffset; }
  function headerH() { return parseFloat(win.getComputedStyle(d.body).getPropertyValue('--header-height')) || 0; }

  var introWait = (!reduced && d.querySelector('.ps-intro') && !root.classList.contains('ps-skip-intro')) ? 1250 : 0;

  /* ---------- 1. Texto por palabras (titulares y manifiesto) ---------- */
  function splitNode(node, state, scrub) {
    Array.prototype.slice.call(node.childNodes).forEach(function (n) {
      if (n.nodeType === 3) {
        var frag = d.createDocumentFragment();
        var first = true;
        n.nodeValue.split(/(\s+)/).forEach(function (p) {
          if (!p) return;
          var isFirst = first; first = false;
          if (/^\s+$/.test(p)) { frag.appendChild(d.createTextNode(' ')); return; }
          // Signo pegado a una palabra de un elemento anterior (p. ej. <em>estilo</em>.): va dentro de esa palabra para que nunca quede solo en otra línea.
          if (isFirst && n.previousSibling && n.previousSibling.nodeType === 1) {
            var prevWords = n.previousSibling.querySelectorAll(scrub ? '.ps-sw' : '.ps-wi');
            if (prevWords.length) {
              var pn = d.createElement('span');
              pn.className = 'ps-pn';
              pn.textContent = p;
              prevWords[prevWords.length - 1].appendChild(pn);
              return;
            }
          }
          var w = d.createElement('span');
          w.setAttribute('aria-hidden', 'true');
          if (scrub) {
            w.className = 'ps-sw';
            w.textContent = p;
            state.words.push(w);
          } else {
            w.className = 'ps-w';
            var wi = d.createElement('span');
            wi.className = 'ps-wi';
            wi.style.setProperty('--i', state.n);
            wi.textContent = p;
            w.appendChild(wi);
          }
          state.n++;
          frag.appendChild(w);
        });
        node.replaceChild(frag, n);
      } else if (n.nodeType === 1) { splitNode(n, state, scrub); }
    });
  }
  function splitText(el, scrub) {
    if (el.__psSplit) return null;
    el.__psSplit = true;
    el.setAttribute('aria-label', el.textContent.replace(/\s+/g, ' ').trim());
    var state = { n: 0, words: [] };
    splitNode(el, state, scrub);
    el.classList.add('ps-ready');
    return state.words;
  }

  /* ---------- 2. Aparición al entrar en pantalla ---------- */
  function setupReveals(scope) {
    $$('[data-ps-stagger]', scope).forEach(function (box) {
      if (box.__psStag) return;
      box.__psStag = true;
      var step = parseInt(box.getAttribute('data-ps-stagger'), 10) || 90;
      Array.prototype.slice.call(box.children).forEach(function (c, i) {
        c.setAttribute('data-ps-reveal', '');
        c.style.setProperty('--ps-delay', (i * step) + 'ms');
      });
    });

    var els = $$('[data-ps-reveal],[data-ps-split]', scope).filter(function (el) { return !el.__psSeen; });
    els.forEach(function (el) {
      el.__psSeen = true;
      if (el.hasAttribute('data-ps-split')) splitText(el, false);
      var dl = el.getAttribute('data-ps-delay');
      if (dl) el.style.setProperty('--ps-delay', dl + 'ms');
    });

    if (reduced || !('IntersectionObserver' in win)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -7% 0px', threshold: 0.1 });
    els.forEach(function (el) {
      if (introWait && el.closest('[data-ps-hero]')) { setTimeout(function () { io.observe(el); }, introWait); } else { io.observe(el); }
    });
  }

  /* ---------- 3. Cursor propio (solo ratón) ---------- */
  function setupCursor() {
    if (!fine || reduced || d.querySelector('.ps-cursor')) return;
    var c = d.createElement('div');
    c.className = 'ps-cursor';
    c.setAttribute('aria-hidden', 'true');
    var txt = d.createElement('span');
    txt.className = 'ps-cursor__txt';
    c.appendChild(txt);
    d.body.appendChild(c);
    var x = -100, y = -100, tx = -100, ty = -100, on = false, mode = '';
    d.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch') return;
      tx = e.clientX; ty = e.clientY;
      go();
      if (!on) { on = true; x = tx; y = ty; c.classList.add('is-on'); }
      var t = e.target.closest ? e.target : null;
      var lab = t && t.closest('[data-ps-cursor]');
      var link = t && t.closest('a,button,summary,label,input,select,textarea,[role="button"]');
      var next = lab ? 'label' : (link ? 'link' : '');
      if (next !== mode) {
        mode = next;
        c.classList.toggle('is-label', mode === 'label');
        c.classList.toggle('is-link', mode === 'link');
        txt.textContent = lab ? lab.getAttribute('data-ps-cursor') : '';
      }
      c.classList.toggle('is-dark', !!(t && t.closest('[data-ps-dark]')));
    }, { passive: true });
    d.documentElement.addEventListener('mouseleave', function () { on = false; c.classList.remove('is-on'); });
    d.addEventListener('pointerdown', function () { c.classList.add('is-down'); });
    d.addEventListener('pointerup', function () { c.classList.remove('is-down'); });
    var running = false;
    function go() { if (!running) { running = true; raf(loop); } }
    function loop() {
      x = lerp(x, tx, 0.2); y = lerp(y, ty, 0.2);
      c.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)';
      if (Math.abs(tx - x) > 0.1 || Math.abs(ty - y) > 0.1) { raf(loop); } else { running = false; }
    }
  }

  /* ---------- 4. Botones magnéticos e inclinación ---------- */
  function setupMagnet(scope) {
    if (!fine || reduced) return;
    $$('[data-ps-magnet]', scope).forEach(function (el) {
      if (el.__psMag) return;
      el.__psMag = true;
      var inner = el.querySelector('.ps-btn__in');
      d.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
        var dx = e.clientX - cx, dy = e.clientY - cy;
        var near = Math.abs(dx) < r.width / 2 + 46 && Math.abs(dy) < r.height / 2 + 46;
        if (near) {
          el.style.transition = 'transform .25s ease-out';
          el.style.transform = 'translate3d(' + (dx * 0.28).toFixed(1) + 'px,' + (dy * 0.38).toFixed(1) + 'px,0)';
          if (inner) { inner.style.transition = 'transform .25s ease-out'; inner.style.transform = 'translate3d(' + (dx * 0.1).toFixed(1) + 'px,' + (dy * 0.14).toFixed(1) + 'px,0)'; }
          el.__hot = true;
        } else if (el.__hot) {
          el.__hot = false;
          el.style.transition = 'transform .9s cubic-bezier(.34,1.56,.64,1)';
          el.style.transform = '';
          if (inner) { inner.style.transition = 'transform .9s cubic-bezier(.34,1.56,.64,1)'; inner.style.transform = ''; }
        }
      }, { passive: true });
    });
  }

  function setupTilt(scope) {
    if (!fine || reduced) return;
    $$('[data-ps-tilt]', scope).forEach(function (el) {
      if (el.__psTilt) return;
      el.__psTilt = true;
      var amt = parseFloat(el.getAttribute('data-ps-tilt')) || 5;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
        el.style.transition = 'transform .2s ease-out';
        el.style.transform = 'perspective(900px) rotateX(' + (-py * amt).toFixed(2) + 'deg) rotateY(' + (px * amt * 1.2).toFixed(2) + 'deg)';
        el.style.setProperty('--mx', px.toFixed(3));
        el.style.setProperty('--my', py.toFixed(3));
      });
      el.addEventListener('pointerleave', function () {
        el.style.transition = 'transform .9s cubic-bezier(.22,1,.36,1)';
        el.style.transform = '';
        el.style.setProperty('--mx', 0);
        el.style.setProperty('--my', 0);
      });
    });
  }

  /* ---------- 5. Carril horizontal (arrastrar, flechas, progreso) ---------- */
  function setupRails(scope) {
    $$('[data-ps-rail]', scope).forEach(function (rail) {
      if (rail.__psRail) return;
      rail.__psRail = true;
      var track = rail.querySelector('.ps-rail__track');
      var bar = rail.querySelector('.ps-rail__bar');
      var prev = rail.querySelector('[data-ps-prev]');
      var next = rail.querySelector('[data-ps-next]');
      if (!track) return;
      function upd() {
        var max = track.scrollWidth - track.clientWidth;
        var p = max > 0 ? track.scrollLeft / max : 0;
        if (bar) bar.style.setProperty('--p', p.toFixed(4));
        rail.classList.toggle('is-static', max <= 4);
        if (prev) prev.disabled = track.scrollLeft < 4;
        if (next) next.disabled = track.scrollLeft > max - 4;
      }
      track.addEventListener('scroll', upd, { passive: true });
      win.addEventListener('resize', upd);
      upd();
      function step(dir) {
        var card = track.querySelector('.ps-card');
        var w = card ? card.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
        track.scrollBy({ left: dir * w * (win.innerWidth > 749 ? 2 : 1), behavior: reduced ? 'auto' : 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      var down = false, sx = 0, sl = 0, moved = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = 0; sx = e.clientX; sl = track.scrollLeft;
      });
      win.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        moved = Math.max(moved, Math.abs(dx));
        if (moved > 4) track.classList.add('is-drag');
        track.scrollLeft = sl - dx;
      });
      win.addEventListener('pointerup', function () {
        if (!down) return;
        down = false;
        track.classList.remove('is-drag');
      });
      track.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  /* ---------- 6. Asa vectorial que responde al cursor (estilo Rive) ---------- */
  var asas = [];
  var ASA = { cx: 300, cy: 260, R: 272.7, rest: 46, max: 112 };
  function asaPath(lt, rt) {
    var x0 = ASA.cx - ASA.R, x1 = ASA.cx + ASA.R;
    return 'M' + x0 + ' ' + (ASA.cy - lt).toFixed(1) + 'V' + ASA.cy + 'A' + ASA.R + ' ' + ASA.R + ' 0 0 0 ' + x1 + ' ' + ASA.cy + 'V' + (ASA.cy - rt).toFixed(1);
  }
  function setupAsas(scope) {
    $$('[data-ps-asa]', scope).forEach(function (svg) {
      if (svg.__psAsa) return;
      svg.__psAsa = true;
      var path = svg.querySelector('path');
      if (!path) return;
      var o = { svg: svg, path: path, lt: ASA.rest, rt: ASA.rest, vl: 0, vr: 0, tl: ASA.rest, tr: ASA.rest, tilt: 0, ttilt: 0, vt: 0, hot: false, busy: false, wave: 0 };
      path.setAttribute('d', asaPath(ASA.rest, ASA.rest));
      asas.push(o);
      if ('IntersectionObserver' in win && !reduced) {
        var seen = new IntersectionObserver(function (en) {
          if (en[0].isIntersecting) {
            seen.disconnect();
            var idx = parseInt(svg.getAttribute('data-ps-asa'), 10) || 0;
            setTimeout(function () { o.tl = ASA.max; o.tr = ASA.max; kick(); setTimeout(function () { o.tl = ASA.rest; o.tr = ASA.rest; kick(); }, 380); }, 120 + idx * 140);
          }
        }, { threshold: 0.6 });
        seen.observe(svg);
      }
    });
    if (asas.length && !win.__psAsaLoop) { win.__psAsaLoop = true; if ((fine || touchy) && !reduced) d.addEventListener('pointermove', onAsaPointer, { passive: true }); }
  }
  var asaRunning = false;
  function kick() { if (!asaRunning) { asaRunning = true; raf(asaStep); } }
  function onAsaPointer(e) {
    var best = null, bestD = 1e9;
    asas.forEach(function (o) {
      var r = o.svg.getBoundingClientRect();
      if (!r.width || r.bottom < -200 || r.top > win.innerHeight + 200) { o.tl = o.tr = ASA.rest; o.ttilt = 0; return; }
      var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      var dx = e.clientX - cx, dy = e.clientY - cy;
      var dist = Math.sqrt(dx * dx + dy * dy);
      var reach = Math.max(r.width * 1.5, 150);
      var near = clamp(1 - dist / reach, 0, 1);
      var side = clamp(dx / (r.width * 0.9), -1, 1);
      o.tl = ASA.rest + near * (36 + 30 * clamp(-side, 0, 1));
      o.tr = ASA.rest + near * (36 + 30 * clamp(side, 0, 1));
      o.ttilt = side * 7 * near;
      if (o.svg.hasAttribute('data-ps-hot') && dist < bestD) { bestD = dist; best = { o: o, r: r }; }
    });
    asas.forEach(function (o) {
      if (!o.svg.hasAttribute('data-ps-hot')) return;
      var hot = best && best.o === o && bestD < Math.max(best.r.width * 1.1, 90);
      if (hot !== o.hot) { o.hot = hot; o.svg.classList.toggle('is-hot', hot); }
    });
    kick();
  }
  function asaStep() {
    var moving = false;
    asas.forEach(function (o) {
      o.vl += (o.tl - o.lt) * 0.13; o.vl *= 0.78; o.lt += o.vl;
      o.vr += (o.tr - o.rt) * 0.13; o.vr *= 0.78; o.rt += o.vr;
      o.vt += (o.ttilt - o.tilt) * 0.13; o.vt *= 0.78; o.tilt += o.vt;
      if (Math.abs(o.vl) + Math.abs(o.vr) + Math.abs(o.vt) > 0.02 || Math.abs(o.tl - o.lt) > 0.2 || Math.abs(o.tr - o.rt) > 0.2 || Math.abs(o.ttilt - o.tilt) > 0.05) moving = true;
      if (!isFinite(o.lt + o.rt + o.tilt)) { o.lt = o.rt = ASA.rest; o.vl = o.vr = o.vt = 0; o.tilt = 0; }
      o.path.setAttribute('d', asaPath(clamp(o.lt, 30, 130), clamp(o.rt, 30, 130)));
      o.svg.style.transform = 'rotate(' + o.tilt.toFixed(2) + 'deg)';
    });
    if (moving) { raf(asaStep); } else { asaRunning = false; }
  }

  /* ---------- 7. Foto del hero: se inclina con el mouse, flota y se mueve con el scroll ---------- */
  function setupHeroPhoto(scope) {
    $$('[data-ps-hero-photo]', scope).forEach(function (el) {
      if (el.__psPhoto || reduced) return;
      el.__psPhoto = true;
      var hero = el.closest('[data-ps-hero]') || el.parentNode;
      var img = el.querySelector('img');
      var tx = 0, ty = 0, x = 0, y = 0, on = false, inView = true;
      function paint(t) {
        var r = hero.getBoundingClientRect();
        var sp = clamp(-r.top / ((r.height || 1) * 0.9), 0, 1);
        var fl = Math.sin(t * 0.0008) * 7;
        var rx = y * 5 + Math.cos(t * 0.0006) * 0.6;
        var ry = x * 9 + Math.sin(t * 0.0007) * 1.2 + sp * 12;
        el.style.transform = 'perspective(1200px) translate3d(' + (x * 16).toFixed(1) + 'px,' + (-y * 12 + fl - sp * 70).toFixed(1) + 'px,0) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) scale(' + (1 - sp * 0.08).toFixed(3) + ')';
        if (img) img.style.transform = 'translate3d(' + (-x * 12).toFixed(1) + 'px,' + (y * 10).toFixed(1) + 'px,0) scale(1.1)';
      }
      var running = false;
      function loop(t) {
        if (!on) { running = false; return; }
        x = lerp(x, tx, 0.07); y = lerp(y, ty, 0.07);
        paint(t);
        raf(loop);
      }
      function sync() {
        on = inView && !d.hidden;
        if (on && !running) { running = true; raf(loop); }
      }
      if (fine || touchy) {
        win.addEventListener('pointermove', function (e) {
          if (e.pointerType === 'touch') return;
          var r = hero.getBoundingClientRect();
          tx = clamp(((e.clientX - r.left) / r.width) * 2 - 1, -1.3, 1.3);
          ty = clamp(-(((e.clientY - r.top) / r.height) * 2 - 1), -1.3, 1.3);
        }, { passive: true });
        root.addEventListener('mouseleave', function () { tx = 0; ty = 0; });
      }
      if ('IntersectionObserver' in win) { new IntersectionObserver(function (en) { inView = en[0].isIntersecting; sync(); }, { threshold: 0 }).observe(hero); }
      d.addEventListener('visibilitychange', sync);
      sync();
    });
  }

  /* ---------- 8. Botón para volver arriba ---------- */
  function setupTop() {
    var b = d.querySelector('[data-ps-top]');
    if (!b || b.__psTop) return;
    b.__psTop = true;
    b.addEventListener('click', function () {
      var w = mqWrap.matches ? getWrap() : null;
      var tgt = w || win;
      try { tgt.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' }); } catch (e) { tgt.scrollTo(0, 0); }
    });
  }

  /* ---------- 9. Efectos ligados al scroll ---------- */
  var parallax = [], scrubs = [], draws = [], marquees = [], vh = win.innerHeight;

  function setupScroll(scope) {
    $$('[data-ps-parallax]', scope).forEach(function (el) {
      if (el.__psPx) return;
      el.__psPx = true;
      parallax.push({ el: el, k: parseFloat(el.getAttribute('data-ps-parallax')) || 0.1, cur: 0 });
    });
    $$('[data-ps-scrub-section]', scope).forEach(function (sec) {
      if (sec.__psScrub) return;
      sec.__psScrub = true;
      var txt = sec.querySelector('[data-ps-scrub]');
      if (!txt) return;
      var words = splitText(txt, true) || [];
      if (reduced) { words.forEach(function (w) { w.style.setProperty('--t', 1); }); return; }
      scrubs.push({ sec: sec, words: words, last: -1 });
    });
    $$('[data-ps-draw]', scope).forEach(function (p) {
      if (p.__psDraw) return;
      p.__psDraw = true;
      p.setAttribute('pathLength', '1');
      p.style.strokeDasharray = '1';
      p.style.strokeDashoffset = reduced ? '0' : '1';
      draws.push({ el: p, last: -1 });
    });
    $$('[data-ps-marquee]', scope).forEach(function (m) {
      if (m.__psMq) return;
      m.__psMq = true;
      var track = m.querySelector('.ps-marquee__track');
      if (!track || !track.firstElementChild) return;
      var o = { el: m, track: track, x: 0, gw: 1, vis: true, base: parseFloat(m.getAttribute('data-ps-marquee')) || 0.7 };
      function measure() {
        var group = track.firstElementChild;
        while (track.children.length > 1) track.removeChild(track.lastChild);
        o.gw = group.getBoundingClientRect().width || 1;
        var need = Math.ceil((win.innerWidth * 2) / o.gw) + 1;
        for (var i = 0; i < need; i++) { var cl = group.cloneNode(true); cl.setAttribute('aria-hidden', 'true'); track.appendChild(cl); }
      }
      measure();
      win.addEventListener('resize', measure);
      if (d.fonts && d.fonts.ready) d.fonts.ready.then(measure);
      if ('IntersectionObserver' in win) new IntersectionObserver(function (en) { o.vis = en[0].isIntersecting; if (o.vis) kickScroll(); }, { rootMargin: '120px' }).observe(m);
      marquees.push(o);
    });
    kickScroll();
  }

  var lastY = getY(), vel = 0, dirScroll = 1, lastT = 0, loopOn = false, dirty = true;
  function kickScroll() { dirty = true; if (!loopOn) { loopOn = true; lastT = performance.now(); raf(frame); } }
  win.addEventListener('scroll', function () { dirty = true; kickScroll(); }, { passive: true });
  function bindWrap() { var w = getWrap(); if (w && !w.__psScroll) { w.__psScroll = true; w.addEventListener('scroll', function () { dirty = true; kickScroll(); }, { passive: true }); } }
  win.addEventListener('resize', function () { vh = win.innerHeight; kickScroll(); });

  function frame(now) {
    var dt = Math.min(now - lastT, 50) || 16; lastT = now;
    var y = getY(), dy = y - lastY; lastY = y;
    vel = lerp(vel, dy, 0.14);
    if (Math.abs(dy) > 0.4) dirScroll = dy > 0 ? 1 : -1;
    var active = false;

    if (dirty || Math.abs(vel) > 0.05) {
      parallax.forEach(function (p) {
        var r = p.el.parentNode.getBoundingClientRect();
        if (r.bottom < -300 || r.top > vh + 300) return;
        var t = (r.top + r.height / 2 - vh / 2) * -p.k;
        p.cur = lerp(p.cur, t, 0.14);
        p.el.style.transform = 'translate3d(0,' + p.cur.toFixed(1) + 'px,0)';
        if (Math.abs(p.cur - t) > 0.4) active = true;
      });
      scrubs.forEach(function (s) {
        var r = s.sec.getBoundingClientRect();
        var hh = headerH();
        var total = Math.max(1, r.height - (vh - hh));
        var p = clamp((hh - r.top) / total, 0, 1);
        if (Math.abs(p - s.last) < 0.0008) return;
        s.last = p;
        var n = s.words.length, head = p * (n + 5);
        s.words.forEach(function (w, i) { w.style.setProperty('--t', clamp(head - i, 0, 1).toFixed(3)); });
      });
      draws.forEach(function (o) {
        var r = o.el.getBoundingClientRect();
        var p = clamp((vh * 0.92 - r.top) / (vh * 0.6), 0, 1);
        if (Math.abs(p - o.last) < 0.002) return;
        o.last = p;
        o.el.style.strokeDashoffset = (1 - p).toFixed(4);
      });
      var scrolled = y > 24;
      if (scrolled !== frame.s) { frame.s = scrolled; d.body.classList.toggle('ps-scrolled', scrolled); }
      var far = y > vh * 0.9;
      if (far !== frame.t) { frame.t = far; var tb = d.querySelector('[data-ps-top]'); if (tb) tb.classList.toggle('is-on', far); }
    }

    if (!reduced) {
      marquees.forEach(function (m) {
        if (!m.vis) return;
        var sp = m.base + Math.min(Math.abs(vel) * 0.32, 14);
        m.x += -dirScroll * sp * (dt / 16.67);
        while (m.x <= -m.gw) m.x += m.gw;
        while (m.x > 0) m.x -= m.gw;
        m.track.style.transform = 'translate3d(' + m.x.toFixed(1) + 'px,0,0)';
      });
      active = active || marquees.some(function (m) { return m.vis; });
    }
    dirty = false;
    if (active || Math.abs(vel) > 0.05) { raf(frame); } else { loopOn = false; }
  }

  /* ---------- Arranque ---------- */
  function init(scope) {
    bindWrap();
    setupReveals(scope);
    setupMagnet(scope);
    setupTilt(scope);
    setupRails(scope);
    setupAsas(scope);
    setupHeroPhoto(scope);
    setupTop();
    setupScroll(scope);
    setupCursor();
  }
  function ready() { init(d); win.__psReady = true; }
  if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', ready); } else { ready(); }
  // Editor de temas de Shopify: reactivar al cargar o mover secciones
  d.addEventListener('shopify:section:load', function (e) { init(e.target || d); });
})();
